import { createApp } from 'vue';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { createPinia } from 'pinia';
import router from './router';

const mountEl = document.getElementById("box-picker-app") || document.getElementById("app");

if (mountEl) {
    axios.defaults.baseURL = mountEl.getAttribute('data-apiurl');
    axios.defaults.withCredentials = true;
    window.SweetVegan = mountEl.getAttribute('data-vegan');

    const eventBus = {
        on(event, callback) {
            document.addEventListener(event, (e) => callback(e.detail));
        },
        emit(event, data) {
            document.dispatchEvent(new CustomEvent(event, { detail: data }));
        }
    };

    window.OpenMyBox = function (cartitem) {
        eventBus.emit("editmode", cartitem);
    };

    const pinia = createPinia();
    const app = createApp(App).use(router);

    app.config.globalProperties.$eventBus = eventBus;
    app.use(VueAxios, axios);
    app.use(pinia);

    app.mount(mountEl);
}